//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiPowerStandby } from '@mdi/js'

export default {
  name: 'LayoutPage',
  props: {
    showHeader: {
      type: [Boolean],
      default: true,
    },
  },
  data() {
    return {
      email: localStorage.getItem('userEmail'),
      icons: { mdiPowerStandby },
    }
  },
  computed: {
    title() {
      return this.$store.state.layout.title
    },
    user() {
      return localStorage.getItem('userEmail')
    },
  },
}
